import { expensesApi } from '../api/expensesApi'

export const deleteExpense = async (expenseId: string) => {
  try {
    const { data } = await expensesApi.deleteExpense(expenseId)
    return data
  } catch (error) {
    console.error(`Error deleting expense: `, error)
    throw error
  }
}
